import {
    ALL_LIVE_CHAT,
    LIVE_CHAT_SENT_MESSAGE_ACK,
    LIVE_CHAT_REMOVE_BUSINESS_MESSAGE,
    LIVE_CHAT_UPDATE_RECENT_CHAT,
    HIDE_LIVE_CHAT_POP_UP,
    SCROLL_LIVE_CHAT,
    INCREASE_LIVE_CHAT_INDEX,
    LOGOUT,
} from '../Actions/actionTypes';
import _ from 'lodash';
import sound from "../Sounds/liveChat.mp3";
import {audioFunc} from "../Service/helper";
import {routeName} from "../Service/env";

const initial = {
    liveChatIndex:0,
    showLiveChatPopUp: false
};

export default (state = initial, action) => {
    switch (action.type) {
        case ALL_LIVE_CHAT:
            let AllliveChatScroll = false;

            let allData = state.liveChat;
            if (action.payload.chats && action.payload.chats.length > 0) {
                if (allData && allData.length !== 0) {
                    if (allData[0].dialog_id && (allData[0].dialog_id === (action.payload.chats && action.payload.chats[0].dialog_id))) {

                        // Need Similar obj
                        const result1 = allData.filter(function(o1){
                            return action.payload.chats.some(function(o2){
                                return o1.CommentId == o2.CommentId;          // id is unnique both array object
                            });
                        });
                        console.log(result1);

                        if(result1.length === 0) {
                            allData = allData.reverse();
                            allData = allData.concat(action.payload.chats);
                            allData = allData.reverse();
                        }
                        AllliveChatScroll = true;
                    } else {
                        if (action.payload.chats) {
                            allData = []
                            allData = action.payload.chats.reverse();
                            AllliveChatScroll = true;
                        } else {
                            !allData && (allData = []);
                        }
                    }
                } else {
                    allData =
                        action.payload.chats && action.payload.chats.reverse();
                    AllliveChatScroll = true;
                }
            }

            return _.cloneDeep({...state, liveChat: allData, totalData:action.payload.totalCount, chatReceived:allData ? allData.length : 0 , scroll:AllliveChatScroll});
        case LIVE_CHAT_SENT_MESSAGE_ACK:
            audioFunc(false,false,sound)

            // var audio = new Audio();                     // create audio wo/ src
            // audio.preload = "auto";                      // intend to play through
            // audio.autoplay = true;                       // autoplay when loaded
            // audio.loop = false;
            // audio.muted = false;
            //
            // audio.src =  sound ; // just for example

            let sent_message_ack={
                CommentDetail: JSON.stringify(action.payload.chat_message),
                CommentId:action.payload.chat_id,
                CreatedDate:action.payload.chat_time,
                First_Name:action.payload.firstname,
                GooglePlacedId:action.payload.googlePlacedId,
                Photo:action.payload.photo,
                UserId:action.payload.user_id,
                UserName:action.payload.firstName,
                message_type:action.payload.message_type
            };
            if (state.liveChat) {
                state.liveChat.push(sent_message_ack);
            }
            let UserId = localStorage.getItem('UserId');
            let scroll = action.payload.user_id === UserId;
            let chatElement = document.getElementsByClassName('live-chat-panel');
            if(chatElement.length > 0) {
                if ((chatElement[0].clientHeight + chatElement[0].scrollTop + 5) > chatElement[0].scrollHeight) {
                    scroll = true;
                }
            }
            return _.cloneDeep({...state, scroll:scroll});
        case LIVE_CHAT_REMOVE_BUSINESS_MESSAGE:
            let deleteIndex = _.findIndex(state.liveChat,(chat)=>chat.CommentId === action.payload.chatId);
            if(state.liveChat && (deleteIndex!==-1)) {
                state.liveChat.splice(deleteIndex,1);
            }
            return _.cloneDeep({...state});
        case LIVE_CHAT_UPDATE_RECENT_CHAT:
            let rcIndex = _.findIndex(
                state.liveChat,
                (rc) => rc.GooglePlacedId === action.payload.googlePlacedId.toUpperCase()
            );
            if (rcIndex !== -1) {
                if (state.liveChat) {
                    if (
                        state.liveChat[0].GooglePlacedId ===
                        action.payload.googlePlacedId
                    ) {
                        let chat = {
                            CommentDetail: JSON.stringify(action.payload.chat_message),
                            CommentId: action.payload.chat_id,
                            CreatedDate: action.payload.chat_time,
                            First_Name: action.payload.firstname,
                            GooglePlacedId: action.payload.googlePlacedId,
                            Photo: null,
                            UserId: action.payload.user_id,
                            UserName: action.payload.firstname,
                            message_type: Number(action.payload.message_type),
                        };
                        state.liveChat.push(chat);
                        state.showPopUp = true;
                    }
                    let scrollElement = document.getElementById("chatWrapper");
                    if (scrollElement) {
                        if (
                            scrollElement.clientHeight + scrollElement.scrollTop + 5 >=
                            scrollElement.scrollHeight
                        ) {
                            state.scroll = true;
                        } else {
                            state.scroll = false;
                        }
                    }
                }
            } else {
                let recentChat;
                if (state.liveChat) {
                    recentChat = {
                        CommentDetail: JSON.stringify(action.payload.chat_message),
                        CommentId:action.payload.chat_id,
                        CreatedDate:action.payload.chat_time,
                        First_Name:action.payload.firstname,
                        GooglePlacedId:action.payload.googlePlacedId,
                        Photo:action.payload.photo,
                        UserId:action.payload.user_id,
                        UserName:action.payload.firstName,
                        message_type:action.payload.message_type
                    };
                    state.liveChat.unshift(recentChat);
                } else {
                    recentChat = {
                        unread_count: 1,
                    };
                    let tempRecentChat = [];
                    tempRecentChat.push(recentChat);
                    state.recentChat = tempRecentChat;
                }
            }
            return _.cloneDeep({ ...state });
        case HIDE_LIVE_CHAT_POP_UP:
            return _.cloneDeep({...state,showLiveChatPopUp :action.payload});
        case SCROLL_LIVE_CHAT:
            return _.cloneDeep({...state,scroll:action.payload});
        case INCREASE_LIVE_CHAT_INDEX:
            state.liveChatIndex = state.liveChatIndex + 1;
            return _.cloneDeep({...state});
        case LOGOUT:
            state = {
                liveChatIndex: 0
            };
            return _.cloneDeep({...state});
        default:
            return state;
    }
};
